"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Calculator = function Calculator(_ref) {
  var size = _ref.size,
      color = _ref.color,
      rest = _objectWithoutProperties(_ref, ["size", "color"]);

  return _react.default.createElement("svg", _extends({
    width: size,
    height: size,
    fill: color,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 52 52"
  }, rest), _react.default.createElement("path", {
    d: "M47 50H5a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1h42a1 1 0 0 1 1 1v46a1 1 0 0 1-1 1zM6 48h40V4H6v44z"
  }), _react.default.createElement("path", {
    d: "M43 18H9a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h34a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1zm-33-2h32V8H10v8zM16 25h-6a1 1 0 0 1 0-2h6a1 1 0 0 1 0 2zM29 25h-6a1 1 0 0 1 0-2h6a1 1 0 0 1 0 2zM42.001 25h-6a1 1 0 0 1 0-2h6a1 1 0 0 1 0 2zM16 31h-6a1 1 0 0 1 0-2h6a1 1 0 0 1 0 2zM29 31h-6a1 1 0 0 1 0-2h6a1 1 0 0 1 0 2zM42.001 31h-6a1 1 0 0 1 0-2h6a1 1 0 0 1 0 2zM16 37h-6a1 1 0 0 1 0-2h6a1 1 0 0 1 0 2zM29 37h-6a1 1 0 0 1 0-2h6a1 1 0 0 1 0 2zM42.001 37h-6a1 1 0 0 1 0-2h6a1 1 0 0 1 0 2zM16 43h-6a1 1 0 0 1 0-2h6a1 1 0 0 1 0 2zM29 43h-6a1 1 0 0 1 0-2h6a1 1 0 0 1 0 2zM42.001 43h-6a1 1 0 0 1 0-2h6a1 1 0 0 1 0 2z"
  }));
};

Calculator.displayName = "Calculator";
Calculator.defaultProps = {
  size: 24,
  color: "currentColor"
};
var _default = Calculator;
exports.default = _default;